import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import Iframe from 'react-iframe'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import CardActions from '@material-ui/core/CardActions';
import PropTypes from 'prop-types';
import { setTimeout } from 'timers';

const styles = {
 
    root: {
        width: '100%',
        // minWidth: '150px',
        // height: '500px',
        // minHeight: '350px',
        align: 'center',
        //overflowX: 'auto',
        //display: 'column',
        alignItem: 'center',
        // margin: '0 Auto',
    },
    formControl: {
        // margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        // margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        justifyContent: 'center',
        // margin: '0 Auto',
    },
    InputLabel:{
        fontSize: '14px',
    },
    rightInput:{
        marginLeft: '50px',
    },
    country:{
        marginTop: '15px',
        marginBottom: '10px',
    },
    hkidPassport:{
        marginTop: '15px',
        marginBottom: '10px',
    },
  };

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

class ArbitratorAppointed extends Component {

    render(){
        
        const { classes, src } = this.props; 
        var ArbitratorAcceptedDate = new Date(this.props.caseData.ArbitratorAcceptedDate)
        var lang = localStorage.getItem('language');
        // Hong Kong Arbitration Society appointed Mr Tim Wong as the Arbitrator of the present arbitration proceedings on 26 March 2021.
        
        if (lang == 'en'){
            return(
                    // <form className={classes.root} >
                        <Card className={classes.card}>
                            <CardContent>
                            <FormControl className={classes.margin} required fullWidth>
                                <label style={{ fontSize: '14px'}} >{this.context.t('Hong Kong Arbitration Society appointed')} {this.props.AcceptedArbitratorName ? this.props.AcceptedArbitratorName: this.props.claimantArbitratorName} {this.context.t('as the Arbitrator of the present arbitration proceedings on')} {ArbitratorAcceptedDate.getDate()} {monthNames[ArbitratorAcceptedDate.getMonth()]} {ArbitratorAcceptedDate.getFullYear()}</label>
                            </FormControl>
                            </CardContent>               
                        </Card>
                    // </form>
            );
    }
    else{
        // 香港仲裁公會已於2021年3月26日委任黃添偉先生為本仲裁案件的仲裁員。
        return(
                // <form className={classes.root} > 
                    <Card className={classes.card}>
                        <CardContent>
                        <FormControl className={classes.margin} required fullWidth>
                            <label style={{ fontSize: '14px'}} >{this.context.t('Hong Kong Arbitration Society appointed')}{ArbitratorAcceptedDate.getFullYear()}年{ArbitratorAcceptedDate.getMonth()+1}月{ArbitratorAcceptedDate.getDate()}日委任{this.props.AcceptedArbitratorName ? this.props.AcceptedArbitratorName: this.props.claimantArbitratorName}{this.context.t('as the Arbitrator of the present arbitration proceedings on')}</label>
                        </FormControl>
                        </CardContent>               
                    </Card>
                // </form>
        );
    }
    }
}

// export default withStyles(styles)(ArbitratorAcceptRejectBox);
const mapStateToProps = (state) => {
    return {
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ArbitratorAcceptReject: (caseId, arbitratorId, status) => dispatch(actions.ArbitratorAcceptReject(caseId, arbitratorId, status)),
    }
}

ArbitratorAppointed.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ArbitratorAppointed)));